module.exports = __webpack_public_path__ + "img/blog-1.b376713b.jpg";